require('../../modules/es6.object.freeze');
module.exports = require('../../modules/_core').Object.freeze;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/object/freeze.js
// module id = O4R0
// module chunks = 0 28 29 32 33 34 39 45 46 108 109 110 111 112 113 114 116 117 123 124 125